import styled from '@emotion/styled';
import * as React from 'react';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const ProperBetLogo = observer(
    'ProperBetLogo',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            height='48'
            onClick={onClick}
            viewBox='0 0 196 48'
            width='196'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M196 39.42C196 41.6849 194.164 43.5216 191.899 43.5216C189.634 43.5216 187.798 41.6849 187.798 39.42C187.798 37.155 189.634 35.3184 191.899 35.3184C194.164 35.3184 196 37.155 196 39.42Z'
                fill='#2CC4A0'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M51.2121 4.47803C54.2909 4.47803 56.6278 5.31435 58.2246 6.98698C59.8232 8.65775 60.6225 11.1352 60.6226 14.4212V32.5723C60.6226 36.0045 59.8232 38.6523 58.2246 40.5174C56.6278 42.3806 54.2909 43.3113 51.2121 43.3113C48.1351 43.3113 45.7983 42.3731 44.1997 40.4952C42.6029 38.6153 41.8054 35.9749 41.8054 32.5723V14.4212C41.8054 11.1352 42.6029 8.65775 44.1997 6.98698C45.7983 5.31437 48.1351 4.47803 51.2121 4.47803ZM51.2565 11.4904C49.9854 11.4904 49.3508 12.4526 49.3508 14.3768V32.9719C49.3508 34.0654 49.4821 34.8926 49.7467 35.455C50.0131 36.0175 50.5016 36.2988 51.2121 36.2988C51.893 36.2988 52.3518 36.0027 52.5887 35.4106C52.8255 34.8186 52.9439 33.9914 52.9439 32.9275V14.288C52.9439 13.4591 52.8329 12.7856 52.6109 12.2675C52.3888 11.7495 51.9373 11.4904 51.2565 11.4904Z'
                fill='#132742'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M10.0728 4.83328C13.1192 4.83328 15.2943 5.81762 16.5968 7.78629C17.8994 9.75312 18.5507 12.6293 18.5507 16.4159C18.5507 20.2033 17.9734 23.0584 16.8189 24.9826C15.6643 26.905 13.5929 27.8652 10.6056 27.8652H7.50102V42.9561H0V4.83328H10.0728ZM7.50102 20.9861H7.94127C8.85897 20.9861 9.53249 20.8176 9.96175 20.479C10.391 20.1386 10.6723 19.6501 10.8055 19.0136C10.9387 18.3771 11.0053 17.4668 11.0053 16.2826C11.0053 14.6868 10.8277 13.5331 10.4724 12.8226C10.1172 12.1122 9.40662 11.7568 8.34092 11.7568H7.50102V20.9861Z'
                fill='#132742'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M32.6631 4.83328C34.5253 4.83328 35.9675 5.25516 36.9889 6.09886C38.0102 6.94258 38.6985 8.12674 39.0538 9.65136C39.409 11.1741 39.5866 13.1178 39.5866 15.4833C39.5866 17.6444 39.3054 19.3319 38.7429 20.5456C38.1804 21.7576 37.2035 22.5995 35.8121 23.0732C36.9667 23.31 37.803 23.8873 38.3211 24.805C38.8391 25.7227 39.0982 26.9651 39.0982 28.5313L39.0094 42.9561H31.5529V28.0428C31.5529 26.98 31.3456 26.3 30.9312 26.004C30.5168 25.7079 29.7627 25.5599 28.6702 25.5599V42.9561H20.9471V4.83328H32.6631ZM28.7146 18.947H30.5316C31.5973 18.947 32.1302 17.7924 32.1302 15.4833C32.1302 14.4796 32.0858 13.7255 31.997 13.2222C31.9082 12.719 31.7453 12.3711 31.5085 12.1787C31.2717 11.9863 30.9312 11.8901 30.4872 11.8901H28.7146V18.947Z'
                fill='#132742'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M73.7574 4.83328C76.8039 4.83328 78.9789 5.81762 80.2815 7.78629C81.5841 9.75312 82.2354 12.6293 82.2354 16.4159C82.2354 20.2033 81.6581 23.0584 80.5036 24.9826C79.349 26.905 77.2776 27.8652 74.2903 27.8652H71.1857V42.9561H63.6847V4.83328H73.7574ZM71.1857 20.9861H71.6259C72.5437 20.9861 73.2172 20.8176 73.6464 20.479C74.0757 20.1386 74.3569 19.6501 74.4902 19.0136C74.6234 18.3771 74.69 17.4668 74.69 16.2826C74.69 14.6868 74.5123 13.5331 74.1571 12.8226C73.8018 12.1121 73.0913 11.7568 72.0256 11.7568H71.1857V20.9861Z'
                fill='#132742'
            />
            <path
                d='M99.8964 12.2009H92.3992V19.6131H99.5856V26.8033H92.3992V35.5439H100.385V42.9561H84.6318V4.83328H99.8964V12.2009Z'
                fill='#132742'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M114.632 4.83328C116.494 4.83328 117.937 5.25514 118.958 6.09886C119.979 6.94257 120.668 8.12677 121.023 9.65136C121.378 11.1741 121.556 13.1178 121.556 15.4833C121.556 17.6444 121.275 19.3319 120.712 20.5456C120.15 21.7575 119.173 22.5995 117.781 23.0732C118.936 23.31 119.772 23.8873 120.29 24.805C120.808 25.7227 121.067 26.9651 121.067 28.5313L120.978 42.9561H113.522V28.0428C113.522 26.9799 113.315 26.3 112.9 26.004C112.486 25.7079 111.732 25.5599 110.639 25.5599V42.9561H102.916V4.83328H114.632ZM110.684 18.947H112.501C113.566 18.947 114.099 17.7924 114.099 15.4833C114.099 14.4796 114.055 13.7255 113.966 13.2222C113.877 12.719 113.714 12.3711 113.477 12.1787C113.241 11.9863 112.9 11.8901 112.456 11.8901H110.684V18.947Z'
                fill='#132742'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M144.814 4.83328C147.594 4.83328 149.613 5.51417 150.871 6.87597C152.13 8.2359 152.759 10.4543 152.759 13.5331V15.2169C152.759 18.8582 151.456 21.0332 148.851 21.741C150.449 22.1554 151.574 23.1176 152.226 24.6274C152.877 26.1372 153.203 28.1345 153.203 30.6184C153.203 34.6723 152.596 37.742 151.382 39.8291C150.168 41.9143 147.978 42.9561 144.814 42.9561H134.474V4.83328H144.814ZM141.931 36.21L142.682 36.2544C144.666 36.2544 145.657 35.3088 145.657 33.416V28.6645C145.657 27.5128 145.487 26.6404 145.147 26.0484C144.806 25.4563 144.207 25.1602 143.348 25.1602H141.931V36.21ZM141.931 19.169H143.481C144.133 19.169 144.577 18.9248 144.814 18.4363C145.05 17.9479 145.169 17.2596 145.169 16.3715V12.5562C145.169 11.3128 144.621 10.6911 143.526 10.6911H141.931V19.169Z'
                fill='#132742'
            />
            <path
                d='M170.997 12.2009H163.5V19.6131H170.686V26.8033H163.5V35.5439H171.485V42.9561H155.732V4.83328H170.997V12.2009Z'
                fill='#132742'
            />
            <path
                d='M189.459 12.1565H184.933V42.9561H177.299V12.1565H172.773V4.83328H189.459V12.1565Z'
                fill='#132742'
            />
        </SvgElement>
    )
);
